<template>
  <section class="module-large-box">
      <div class="container">
          <div class="columns is-full">
              <div class="column">
                  <Skeletor width="100%" height="780"/>
              </div>
          </div>
      </div>
  </section>
</template>
<script setup></script>